import { useState } from "react";
import {
  catalogSnapshot,
  integrationStage,
  type IntegrationSnapshot,
} from "@barmetvault/shared";
import {
  PageHeader,
  IntegrationCard,
  ErrorState,
  PermissionDenied,
  EmptyState,
} from "../components/hub/OperationalUI";
import { useHubResource } from "./useHubResource";
export default function IntegrationsCatalog() {
  const result = useHubResource<IntegrationSnapshot[]>("/hub/integrations");
  const [query, setQuery] = useState("");
  const [category, setCategory] = useState("");
  const [stage, setStage] = useState("");
  if (result.state === "denied") return <PermissionDenied />;
  const entries = (result.data ?? catalogSnapshot()).filter(
    (item) =>
      item.name.toLowerCase().includes(query.toLowerCase()) &&
      (!category || item.category === category) &&
      (!stage || integrationStage(item) === stage),
  );
  return (
    <section className="hub-page">
      <PageHeader
        title="Integraciones"
        subtitle="Catálogo, configuración, conexión y salud son estados independientes."
      />
      {result.state === "error" && <ErrorState retry={result.retry} />}
      <p role="status">
        Conexiones no verificadas hasta disponer de comprobación del proveedor.
      </p>
      <div className="hub-filters">
        <label>
          Buscar
          <input
            aria-label="Buscar"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
        </label>
        <label>
          Categoría
          <select
            aria-label="Categoría"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
          >
            <option value="">Todas</option>
            {["BUSINESS", "INFRASTRUCTURE", "INTERNAL"].map((c) => (
              <option key={c}>{c}</option>
            ))}
          </select>
        </label>
        <label>
          Estado
          <select
            aria-label="Estado"
            value={stage}
            onChange={(e) => setStage(e.target.value)}
          >
            <option value="">Todos</option>
            {["CATALOGUED", "CONFIGURED", "CONNECTED", "HEALTHY"].map((c) => (
              <option key={c}>{c}</option>
            ))}
          </select>
        </label>
      </div>
      <div className="hub-grid three">
        {entries.map((item) => (
          <IntegrationCard key={item.id} item={item} />
        ))}
      </div>
      {!entries.length && <EmptyState title="Sin coincidencias" />}
    </section>
  );
}
